import _ from 'lodash';
import { useMemo } from 'react';
import { TAllowedEnums } from '../claimsBatchEdit.type';
import { ItemDropDown } from './ItemEdit';

interface IProps {
  value: string | undefined;
  label?: string;
  allowedItems: TAllowedEnums | undefined;
  onChange: (value: string) => void;
}

export const ItemEditEnumarable = ({
  value,
  label,
  allowedItems,
  onChange,
}: IProps) => {
  const options = useMemo(
    () => _.toPairs(allowedItems)?.map(splitItemToOptions) ?? [],
    [allowedItems],
  );

  return (
    <ItemDropDown
      value={value}
      label={label}
      addEmptyItem
      options={options}
      onChange={onChange}
    />
  );
};

// ============  internal utils  ==============

const splitItemToOptions = ([label, value]: string[]) => ({
  label,
  value,
});
